import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Zap } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export default function TrialBanner() {
  const { user, token } = useAuth();
  const [sub, setSub] = useState(null);

  useEffect(() => {
    if (!user || !token) return;
    axios
      .get(`${API_BASE}/api/me/subscription`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setSub(res.data))
      .catch(() => setSub(null));
  }, [user, token]);

  // Only show during trial (not for active paid plans or expired)
  if (!sub || !sub.is_trialing || sub.is_expired) return null;

  const days = sub.trial_days_remaining;
  const isUrgent = days != null && days <= 2;

  const wrapperClass = isUrgent
    ? 'bg-rose-500/10 border-rose-500/30 text-rose-200'
    : 'bg-[#00FFFF]/5 border-[#00FFFF]/20 text-cyan-100';

  return (
    <div
      className={`border-b px-4 py-2.5 flex items-center justify-between gap-3 text-sm ${wrapperClass}`}
      data-testid="trial-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Clock className={`h-4 w-4 flex-shrink-0 ${isUrgent ? 'text-rose-400' : 'text-[#00FFFF]'}`} />
        <span className="truncate">
          <strong>
            {days === 0
              ? 'Seu teste grátis termina hoje.'
              : days === 1
              ? 'Faltam apenas 1 dia do seu teste grátis.'
              : `Faltam ${days} dias do seu teste grátis.`}
          </strong>{' '}
          <span className="hidden sm:inline opacity-80">
            Ative um plano para continuar usando todos os recursos.
          </span>
        </span>
      </div>
      <Link
        to="/billing"
        className={`flex-shrink-0 inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-semibold transition-colors ${
          isUrgent
            ? 'bg-rose-500 hover:bg-rose-600 text-white'
            : 'bg-gradient-to-r from-[#0033FF] to-[#0099FF] hover:from-[#0044FF] hover:to-[#00AAFF] text-white'
        }`}
        data-testid="trial-cta-btn"
      >
        <Zap className="h-3 w-3" />
        Ativar plano
      </Link>
    </div>
  );
}
